import { render, staticRenderFns } from "./add-garage.vue?vue&type=template&id=0f1434ee"
import script from "./add-garage.vue?vue&type=script&lang=ts"
export * from "./add-garage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports